import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Normalize API error detail to a string (avoids rendering objects as React children). */
export function getApiErrorMessage(detail, fallback = "Request failed") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (typeof first === "object" && first !== null && first.msg != null) return String(first.msg);
    if (typeof first === "string") return first;
  }
  if (typeof detail === "object" && detail !== null && detail.msg != null) return String(detail.msg);
  return fallback;
}
